import { gql } from '@apollo/client';

export const QUERY_SHOP_ELEVE = gql`
  query GetShopEleve($id: ID!, $classeId: ID!) {
    eleve(id: $id, classeId: $classeId) {
      avatar {
        media {
          url
        }
      }
      ong
      email
      firstname
      lastname
      role
      note {
        updatedAt
      }
      classe {
        debut
        fin
        operationid
        lycee {
          name
          ville
        }
      }
    }
  }
`;
